import useMessagesStore from '🔗/stores/messages';
import useModalsStore from '🔗/stores/modals';
import useOthersStore from '🔗/stores/others';
import useUserStore from '🔗/stores/user';
import useLocaleStore from '🔗/stores/locale';
import usePixiStore from '🔗/stores/pixi';
import useSettingsStore from '🔗/stores/settings';
import useMessengersStore from '🔗/stores/messengers';
import usePlayerStore from '🔗/stores/player';
import useTgsStore from '🔗/stores/tgs';
import usePlayerPluginStore from '🔗/stores/playerPlugin';
import useFavoriteStore from '🔗/stores/favorite';
import useAppPluginStore from '🔗/stores/appPlugin';

const stores = {
    get messages() { return useMessagesStore; },
    get modals() { return useModalsStore; },
    get others() { return useOthersStore; },
    get user() { return useUserStore; },
    get locale() { return useLocaleStore; },
    get pixi() { return usePixiStore; },
    get messengers() { return useMessengersStore; },
    get settings() { return useSettingsStore; },
    get player() { return usePlayerStore; },
    get playerPlugin() { return usePlayerPluginStore; },
    get tgs() { return useTgsStore; },
    get favorite() { return useFavoriteStore; },
    get appPlugin() { return useAppPluginStore; }
};

export default stores;
